import styled, { css } from "styled-components";
import InputText from "../InputText";

export const Wrapper = styled.div`
  width: 100%;
  position: relative;
`;

export const Main = styled.main`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    width: 100%;
  `}
`;

export const Label = styled.main`
  ${({ theme }) => css`
    font-weight: 500;
    padding-bottom: 1rem;
    color: ${theme.colors.gray};
    font-size: ${theme.font.sizes.large};
    font-family: Roboto !important;
  `}
`;

export const Select = styled.div`
  width: 100%;
  display: flex;

  ${({ theme }) => css`
    color: ${theme.colors.lineBlue};
    padding: 0;
    padding-top: 0;
    padding-bottom: 0;
    position: absolute;

    svg {
      position: relative;
      margin-top: 6px;
    }
  `}
  .Entrada {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 130px;
    padding-top: 9px;
  }
`;

export const Title = styled.p`
  ${({ theme }) => css`
    color: ${theme.colors.black};
    font-size: ${theme.font.sizes.small};
    margin-bottom: 0.3rem;
    font-weight: bold;
    letter-spacing: 0.3rem;
  `}
`;

export const Options = styled.div`
  ${({ theme }) => css`
    position: absolute;
    bottom: 9rem;
    border: 1px solid ${theme.colors.graySecondary};
    padding: 0rem 1.2rem 0.5rem 0.5rem;
    max-height: 13rem;
    overflow: auto;
    z-index: 9999999;
    background-color: ${theme.colors.white};
    margin-bottom: -99px !important;
    margin-left: -5px;
  `}
`;

export const Option = styled.div`
  ${({ theme }) => css`
    color: ${theme.colors.gray};
    padding: 0.3rem 0;
    cursor: pointer;

    &:last-child {
      border: none;
    }
  `}
`;
export const Description = styled.p`
  ${({ theme }) => css`
    color: ${theme.colors.black};
    font-weight: large;
    font-size: ${theme.font.sizes.xsmall};
    .hover:hover {
      color: ${theme.colors.lineBlue};
    }
  `}
`;

export const Selected = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const InputSearch = styled.input`
  ${({ theme }) => css`
    width: 100%;
    height: 3.3rem;
    border: none;
    margin-bottom: 0.5rem;
    caret-color: transparent;
    padding-top: 0;
    font-size: 1.3rem;
    font-family: Roboto !important;
    color: ${theme.colors.lineBlue};

    ::placeholder {
      font-family: Roboto !important;
      color: ${theme.colors.lineBlue};
    }
  `}
`;
